export default "__VITE_ASSET__4lwNmsJH__"